<template>
  <v-combobox
    v-model="model"
    :filter="filter"
    :hide-no-data="!search"
    :items="items"
    :search-input.sync="search"
    hide-selected
    label="Add tag"
    multiple
    small-chips
    solo
  >
    <template slot="no-data">
      <v-list-tile>
        <span class="subheading">Create</span>
        <v-chip
          color="primary white--text"
          label
          small
        >
          {{ search }}
        </v-chip>
      </v-list-tile>
    </template>
    <template
      v-if="item === Object(item)"
      slot="selection"
      slot-scope="{ item, parent, selected }"
    >
      <v-chip
        color="primary white--text"
        :selected="selected"
        label
        small
      >
        <span class="pr-2">
          {{ item.text }}
        </span>
        <v-icon
          small
          @click="parent.selectItem(item); deleteTag(item);"
        >close</v-icon>
      </v-chip>
    </template>
    <template
      slot="item"
      slot-scope="{ index, item, parent }"
    >
      <v-list-tile-content @click="addTagToKeyword(item)">
        <v-text-field
          v-if="editing === item"
          v-model="editing.text"
          autofocus
          flat
          background-color="transparent"
          hide-details
          solo
          @keyup.enter="edit(index, item)"
        ></v-text-field>
        <v-chip
          v-else
          color="primary white--text"
          dark
          label
          small
        >
          {{ item.text }}
        </v-chip>
      </v-list-tile-content>
      <v-spacer></v-spacer>
    </template>
  </v-combobox>
</template>

<script>
export default {
  name: 'TagMultipleSelect',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['projectId', 'keywordId', 'tags', 'loading'],
  data: () => ({
    activator: null,
    attach: null,
    editing: null,
    index: -1,
    items: [
      { header: 'Select a tag or create one' }
    ],
    nonce: 1,
    menu: false,
    model: [
      {
        text: 'Foo'
      }
    ],
    search: null
  }),
  mounted () {
    this.model = this.tags.map((tag) => {
      return {text: tag}
    })
    this.items = this.items.concat(this.model)
  },
  watch: {
    model (val, prev) {
      if (val.length === prev.length) return
      if (!val.length) return
      if (val[val.length - 1] && typeof val[val.length - 1] === 'string' && !val[val.length - 1].trim()) return

      this.model = val.map(v => {
        if (typeof v === 'string' && v.trim()) {
          v = {
            text: v
          }

          this.items.push(v)

          this.addTagToKeyword(v)

          this.nonce++
        }

        return v
      })
    }
  },
  methods: {
    addTagToKeyword (tag) {
      console.log('add', tag.text)
      this.$parent.$emit('loading', true)
      this.$store.dispatch('ADD_TAG', {projectId: this.projectId, keywordId: this.keywordId, tag: tag.text}).then(res => {
        this.$parent.$emit('loading', false)
        this.$toasted.show('Tag was successfully added')
      }, err => {
        console.log('DELETE_TAG ERROR', err)
        this.$parent.$emit('loading', false)
        this.$toasted.show('DELETE_TAG ERROR: ' + this.$services.getApiError(err), { type: 'error' })
      })
    },
    deleteTag (tag) {
      console.log('delete', tag.text)
      this.$parent.$emit('loading', true)
      this.$store.dispatch('DELETE_TAG', {projectId: this.projectId, keywordId: this.keywordId, tag: tag.text}).then(res => {
        this.$parent.$emit('loading', false)
        this.$toasted.show('Tag was successfully deleted')
      }, err => {
        console.log('DELETE_TAG ERROR', err)
        this.$parent.$emit('loading', false)
        this.$toasted.show('DELETE_TAG ERROR: ' + this.$services.getApiError(err), { type: 'error' })
      })
    },
    edit (index, item) {
      console.log('edit', item.text)
      if (!this.editing) {
        this.editing = item
        this.index = index
      } else {
        this.editing = null
        this.index = -1
      }
    },
    filter (item, queryText, itemText) {
      if (item.header) return false

      const hasValue = val => val != null ? val : ''

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString()
        .toLowerCase()
        .indexOf(query.toString().toLowerCase()) > -1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tag-multiple-select/TagMultipleSelect.vue